import React from 'react';
import Nav from '../../components/Nav';
import MixpanelService from '../../services/MixpanelService';
import ROUTES from '../../components/Routes/constants';

const mixpanel = MixpanelService.get();

const renderNavItems = (
  items,
  pathname,
  updatePositionHandler,
  tradeState,
  locale
) =>
  items.map(({ id, testId, context, linkTo, label, labelFr }) => {
    let isActive = false;
    if (pathname === ROUTES.PAYMENTS_ON_HOLD) {
      isActive = false;
    } else if (pathname.includes(linkTo)) {
      isActive = true;
    } else {
      isActive = tradeState ? context === tradeState : false;
    }

    return (
      <Nav.Item
        key={id}
        id={id}
        testId={testId}
        context={context}
        linkTo={linkTo}
        updatePositionHandler={updatePositionHandler}
        isActive={isActive}
        onClick={() => {
          mixpanel.trackNavActivity(linkTo, context);
        }}
      >
        {locale === 'fr-CA' ? labelFr : label}
      </Nav.Item>
    );
  });

export default renderNavItems;
